import { TranslationScope } from '../models/translation-scope.model';

export const TranslationScopes: TranslationScope = {
    loginModule: {
        scope: 'LOGIN_MODULE',
    },
    header: {
        scope: 'HEADER',
    },
    users: {
        scope: 'USERS.',
    },
    stores: {
        scope: 'FACILITIES.',
    },
    chains: {
        scope: 'FACILITIES.',
    },
    web: {
        scope: 'WEB.',
    },
};
